import { useCallback } from "react";
import { useAppSelector } from "store";

/**
 * The showcase asset for `slotKey`, or the bundled `fallback` when backoffice has not published one.
 *
 * Slot keys are the backoffice "Site Görselleri" catalogue's (`backoffice_v2 scripts/site_image_slots.json`);
 * an unknown key simply returns the fallback, so a typo degrades to today's picture rather than a blank.
 */
export const useSiteImage = (slotKey: string, fallback: string): string => useAppSelector((s) => s.siteImages.images[slotKey]?.url) ?? fallback;

/** A video slot's url AND poster. The poster is null unless backoffice uploaded one with that video. */
export const useSiteMedia = (slotKey: string, fallback: string): { url: string; posterUrl: string | null } => {
  const entry = useAppSelector((s) => s.siteImages.images[slotKey]);

  return { url: entry?.url ?? fallback, posterUrl: entry?.posterUrl ?? null };
};

/**
 * For module-scope data (demo frame lists, course catalogues, help-video maps) that cannot call a hook per
 * item: resolve each `(slotKey, fallback)` pair at render time, inside the component that renders the list.
 */
export const useSiteImageResolver = (): ((slotKey: string, fallback: string) => string) => {
  const images = useAppSelector((s) => s.siteImages.images);

  return useCallback((slotKey: string, fallback: string) => images[slotKey]?.url ?? fallback, [images]);
};
